import {get} from "lodash"
import {Response} from '@angular/http';
import {getClientErrorTypeByStatus} from "./client.error.type";
import {ClientErrorCode, getClientErrorCodeByServerCode} from "./client.error.code";
import {ClientErrorResponse} from "./client.error.response";

export function getClientErrorResponse(error: Response): ClientErrorResponse {
    const clientErrorResponse: ClientErrorResponse = new ClientErrorResponse;
    clientErrorResponse.status = error.status;
    clientErrorResponse.type = getClientErrorTypeByStatus(error.status);

    try {
        let response: any = error.json();
        clientErrorResponse.errorCode = getClientErrorCodeByServerCode(get(response, 'code'));
        clientErrorResponse.errorMessage = get(response, 'message');
        clientErrorResponse.errorArguments = get(response, 'messageArgs');
    } catch (e) {
        clientErrorResponse.errorCode = ClientErrorCode.ERR001;
        clientErrorResponse.errorMessage = "Unexpected system error!";
        clientErrorResponse.errorArguments = {};
    }

    return clientErrorResponse;
}

export function getClientErrorResponseFromJson(error: Response): ClientErrorResponse {
    const clientErrorResponse: ClientErrorResponse = new ClientErrorResponse;
    clientErrorResponse.status = error.status;
    clientErrorResponse.type = getClientErrorTypeByStatus(error.status);

    try {
        clientErrorResponse.errorCode = getClientErrorCodeByServerCode(get(error, 'code'));
        clientErrorResponse.errorMessage = get(error, 'message');
        clientErrorResponse.errorArguments = get(error, 'messageArgs');
    } catch (e) {
        clientErrorResponse.errorCode = ClientErrorCode.ERR001;
        clientErrorResponse.errorMessage = "Unexpected system error!";
        clientErrorResponse.errorArguments = {};
    }

    return clientErrorResponse;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/entity/client.error.factory.ts